var _rect, _text, _text2, _text3, _rect2, _text4, _text5, _rect3, _text6, _text7, _rect4, _text8, _rect5, _text9, _text10, _text11, _text12, _text13, _text14, _text15, _text16, _line, _text17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCase4Fig5OriginExchange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 520",
    fontFamily: "Geist, 'Segoe UI', -apple-system, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 520,
    fill: "#FFFDF7"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 52,
    fontSize: 22,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "The exchange that started it")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 76,
    fontSize: 14,
    fill: "#4A5F56"
  }, "2026-02-11, months before STUD existed")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 130,
    fontSize: 11,
    letterSpacing: "0.1em",
    fontWeight: 600,
    fill: "#6B7F74"
  }, "DAN")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 142,
    width: 620,
    height: 46,
    rx: 10,
    fill: "#F5F2E8"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 171,
    fontSize: 14,
    fill: "#1A2F2A",
    fontStyle: "italic"
  }, "presses on how much is actually remembered between sessions")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 230,
    fontSize: 11,
    letterSpacing: "0.1em",
    fontWeight: 600,
    fill: "#6B7F74"
  }, "CLAUDE")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 242,
    width: 620,
    height: 60,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#7C3AED",
    strokeWidth: 2
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 279,
    fontSize: 17,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "&#8220;Fair call-out. I was overselling it.&#8221;")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 344,
    fontSize: 11,
    letterSpacing: "0.1em",
    fontWeight: 600,
    fill: "#6B7F74"
  }, "THE CHECK")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 356,
    width: 620,
    height: 46,
    rx: 10,
    fill: "#F5F2E8"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 385,
    fontSize: 14,
    fill: "#1A2F2A"
  }, "The global configuration was empty across dozens of projects.")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 708,
    y: 142,
    width: 244,
    height: 260,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#16A34A",
    strokeWidth: 2
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 732,
    y: 176,
    fontSize: 11,
    letterSpacing: "0.1em",
    fontWeight: 600,
    fill: "#16A34A"
  }, "WHAT IT PRODUCED")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 732,
    y: 208,
    fontSize: 14,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "The durability hierarchy")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 732,
    y: 240,
    fontSize: 13.5,
    fill: "#4A5F56"
  }, "1. settings")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 732,
    y: 266,
    fontSize: 13.5,
    fill: "#4A5F56"
  }, "2. instructions")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 732,
    y: 292,
    fontSize: 13.5,
    fill: "#4A5F56"
  }, "3. memory")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 732,
    y: 318,
    fontSize: 13.5,
    fill: "#4A5F56"
  }, "4. session")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 732,
    y: 352,
    fontSize: 12.5,
    fill: "#4A5F56"
  }, "A lesson lives at the highest")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 732,
    y: 370,
    fontSize: 12.5,
    fill: "#4A5F56"
  }, "layer it can survive in.")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 668,
    y1: 272,
    x2: 708,
    y2: 272,
    stroke: "#16A34A",
    strokeWidth: 1.5
  })), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 474,
    fontSize: 12,
    fill: "#6B7F74"
  }, "Recreated from the archived 2026-02-11 exchange. The reply is quoted verbatim; the surrounding beats are described.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase4Fig5OriginExchange);
export default __webpack_public_path__ + "static/media/case4-fig5-origin-exchange.8187d3de901d7566079e4bd9e649a21b.svg";
export { ForwardRef as ReactComponent };